import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const createTag = createAsyncThunk(
  "tags/createTag",
  async ({ token, payload }) => {
    const response = await api.post("/tags", { ...payload }, { token });
    return response.data;
  }
);

export const getAllTags = createAsyncThunk(
  "tags/getAllTags",
  async ({ token, ...queryParams }) => {
    const response = await api.get("/tags", {
      token,
      params: queryParams,
    });
    return response.data;
  }
);

export const updateTag = createAsyncThunk(
  "tags/updateTag",
  async ({ token, id, payload }) => {
    const response = await api.patch(`/tags/${id}`, { ...payload }, { token });
    return response.data;
  }
);

export const deleteTag = createAsyncThunk(
  "tags/deleteTag",
  async ({ token, id }) => {
    const response = await api.delete(`/tags/${id}`, { token });
    return response.data;
  }
);
